
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/[id]",
      function () {
        return require("private-next-pages/teams/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/[id]"])
      });
    }
  